module.exports = __webpack_public_path__ + "static/img/PL@3x.f37dfaf5.jpg";